<template>
  <base-section
    id="venuewrapper"
    :space="0"
  >
    <v-container>
      <div>
        <v-tabs
          id="tab-venuewrapper"
        >
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-venice`"
            @click="goToTop"
          >
            City of Venice
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-venue`"
            @click="goToTop"
          >
            Congress Center
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-how-to`"
            @click="goToTop"
          >
            How To Reach
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-tips-tricks`"
            id="tips-tricks"
            @click="goToTop"
          >
            Tips & Tricks
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-hotelrooms`"
            @click="goToTop"
          >
            Hotel Suggestions
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-visa`"
            @click="goToTop"
          >
            Visa
          </v-tab>
          <v-tab-item
            :value="`tab-venice`"
          >
            <venice />
          </v-tab-item>
          <v-tab-item
            :value="`tab-venue`"
          >
            <venue />
          </v-tab-item>
          <v-tab-item
            :value="`tab-how-to`"
          >
            <how-to />
          </v-tab-item>
          <v-tab-item
            :value="`tab-tips-tricks`"
          >
            <tips-tricks />
          </v-tab-item>
          <v-tab-item
            :value="`tab-hotelrooms`"
          >
            <hotel-rooms />
          </v-tab-item>
          <v-tab-item
            :value="`tab-visa`"
          >
            <visa />
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
  </base-section>
</template>
<script>
  import Venue from './Venue.vue'
  import Venice from './Venice.vue'
  import HotelRooms from './HotelRooms.vue'
  import Visa from './Visa.vue'
  import HowTo from './HowTo.vue'
  import TipsTricks from './TipsTricks.vue'
  export default {
    name: 'VenueWrapper',
    components: { Venue, Venice, HotelRooms, Visa, HowTo, TipsTricks },

    data: () => ({
      tab: null,
      items: [
        'City of Venice',
        'Congress Center',
        'Hotel Rooms',
      ],
    }),
    mounted () {
      var section = this.$router.currentRoute.hash.replace('#tab-', '')
      var mobile = this.isMobileDevice()
      if (section && !mobile) {
        document.getElementById(section).click()
      }
      document.getElementById('tab-venuewrapper').firstChild.style = 'position: fixed; background-color: #fafafa !important; width = 100%; margin-top: -11px; z-index: 5; width: 100%;'
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      goToTop () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  }
</script>
